import React, { useCallback } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleInfo, faTimes } from '@fortawesome/pro-regular-svg-icons'

import SIGNING_HELP_CONTENT from './content'
import './signing_help.css'

const MODAL_ID = 'signingHelpModal'

/** Matches, in order: a bold link, a bold run, a plain link. */
const RICH_TEXT_TOKEN = /\*\*\[([^\]]+)]\(([^)]+)\)\*\*|\*\*([^*]+)\*\*|\[([^\]]+)]\(([^)]+)\)/g

function externalLink (text, href, key) {
  return (
    <a key={key} className='signing-help-link' href={href} target='_blank' rel='noreferrer'>{text}</a>
  )
}

/** Renders the bold runs and links the content file carries over from the source document. */
function richText (text) {
  const nodes = []
  let lastIndex = 0
  let match
  RICH_TEXT_TOKEN.lastIndex = 0
  while ((match = RICH_TEXT_TOKEN.exec(text)) !== null) {
    const [full, boldLinkText, boldLinkHref, boldText, linkText, linkHref] = match
    if (match.index > lastIndex) nodes.push(text.slice(lastIndex, match.index))
    if (boldLinkText) {
      nodes.push(<strong key={match.index}>{externalLink(boldLinkText, boldLinkHref, match.index)}</strong>)
    } else if (boldText) {
      nodes.push(<strong key={match.index}>{boldText}</strong>)
    } else {
      nodes.push(externalLink(linkText, linkHref, match.index))
    }
    lastIndex = match.index + full.length
  }
  if (lastIndex < text.length) nodes.push(text.slice(lastIndex))
  return nodes
}

const SigningHelp = React.memo(function SigningHelp () {
  const show = useCallback(() => window.$(`#${MODAL_ID}`).modal('show'), [])
  const hide = useCallback(() => window.$(`#${MODAL_ID}`).modal('hide'), [])

  return (
    <>
      <button
        type='button'
        className='signing-help-btn'
        onClick={show}
        title={SIGNING_HELP_CONTENT.title}
        aria-label={SIGNING_HELP_CONTENT.title}
      >
        <FontAwesomeIcon icon={faCircleInfo} />
      </button>

      <div
        className='modal fade signing-help-modal'
        id={MODAL_ID}
        tabIndex='-1'
        role='dialog'
        aria-labelledby={`${MODAL_ID}Title`}
        aria-hidden='true'
      >
        <div className='modal-dialog modal-dialog-centered modal-dialog-scrollable' role='document'>
          <div className='modal-content signing-help-content'>
            <div className='modal-header signing-help-header'>
              <h5 className='modal-title signing-help-title' id={`${MODAL_ID}Title`}>
                {SIGNING_HELP_CONTENT.title}
              </h5>
              <button type='button' className='signing-help-close' aria-label='Fechar' onClick={hide}>
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>

            <div className='modal-body signing-help-body'>
              {SIGNING_HELP_CONTENT.intro.map((paragraph, index) => (
                <p className='signing-help-paragraph' key={index}>{richText(paragraph)}</p>
              ))}

              {SIGNING_HELP_CONTENT.sections.map((section, sectionIndex) => (
                <section className='signing-help-section' key={sectionIndex}>
                  <h6 className='signing-help-section-title'>{section.title}</h6>
                  {section.groups.map((group, groupIndex) => (
                    <div className='signing-help-group' key={groupIndex}>
                      {group.title && <p className='signing-help-group-title'>{group.title}</p>}
                      <ul className='signing-help-list'>
                        {group.items.map((item, itemIndex) => <li key={itemIndex}>{richText(item)}</li>)}
                      </ul>
                    </div>
                  ))}
                  {section.note && <p className='signing-help-note'>{richText(section.note)}</p>}
                </section>
              ))}

              {SIGNING_HELP_CONTENT.callouts.map((callout, index) => (
                <div className='signing-help-callout' key={index}>
                  <span className='signing-help-callout-title'>{callout.title}</span>
                  <span className='signing-help-callout-text'>{richText(callout.text)}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  )
})

export default SigningHelp
